/**
 * Every menu screen by route (docs/spec/04 §6). The game ('play') is the app's; everything else is
 * built here.
 */

import type { Route, Scene, SceneHost } from '../scene';
import { ControlsScene } from './controls';
import { CreditsScene } from './credits';
import { DailyScene } from './daily';
import { HelpScene } from './help';
import { HiscoresScene } from './hiscores';
import { InitialsScene } from './initials';
import { OptionsScene } from './options';
import { TitleScene } from './title';

/** The scene for `route`: every menu screen; the title's menu for `'play'`. */
export function createUiScene(route: Route, host: SceneHost): Scene {
  switch (route.to) {
    case 'title': return new TitleScene(host, route.skipPress === true);
    case 'daily': return new DailyScene(host);
    case 'options': return new OptionsScene(host);
    case 'controls': return new ControlsScene(host);
    case 'hiscores': return new HiscoresScene(host, route.table, route.highlight);
    case 'help': return new HelpScene(host);
    case 'credits': return new CreditsScene(host);
    case 'initials': return new InitialsScene(host, route.entry);
    // The app builds the game itself; should 'play' arrive here, the title is the safe answer.
    case 'play': return new TitleScene(host, true);
  }
}
